<template>
  <div >
    <ClientComponent></ClientComponent>


  </div>
</template>
<script>
import ClientComponent from "../Components/ClientComponent";
export default {
  name: "Client",
  components: {
    ClientComponent
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>
